export interface WithdrawalFeesSetting {
    FeeAmount: number;
    FeeType: FeeType;
    FromAmount: null | string;
    PaymentMethod: PaymentMethod;
    PaymentMethodId: number;
    ToAmount: null | string;
}

export interface WithdrawalFeesDto {
    FreeWithdrawalFeesInPeriod: number;
    WithdrawalFeeEnabled: boolean;
    WithdrawalFeeEndPeriod: null | string;
    WithdrawalFeeStartPeriod: null | string;
    WithdrawalFeesSettings: WithdrawalFeesSetting[];
    WithdrawalsFeesCount: null | number;
}

enum FeeType {
    Percentage = 'Percentage',
    FixedAmount = 'FixedAmount',
}

export enum PaymentMethod {
    Agency = 'Agency',
    BankTransfer = 'BankTransfer',
    Instant = 'Instant',
    Online = 'Online',
}
